import router from '@/router'
import analyticsState from '@/store/modules/analytics/state'
// model
import { exampleList } from '@/pages/your-reports/model/report-example'

export const goToEntity = (id, type = 'view') => {
  if (id) {
    const routeData = router.resolve({ path: `entity-explorer/${type}/${id}` })
    window.open(routeData.href, '_blank')
  }
}

export const goMailto = link => {
  if (!link) return
  window.location.href = `mailto:${link}`
}

export const contactSatoshieyeSupport = () => {
  window.location.href = 'mailto:support@satoshieye.com'
}

export const linkDataFormatter = (val, coin, type = 'address') => {
  const explorerData = analyticsState.currencyList.find(el => el.key === coin)

  return {
    link:
      type === 'tx' || type === 'transaction'
        ? explorerData.explorerTx
            .replace('{VALUE}', val)
            .replace('{TYPE}', type)
        : explorerData.explorerAddr
            .replace('{VALUE}', val)
            .replace('{TYPE}', type) || '',
  }
}

export const windowOpenLink = (link, target = '_blank') => {
  if (!link) return
  window.open(link, target)
}

export const openExample = type => {
  const target = exampleList.find(e => e.exampleId == type)
  if (!target) return
  let anchor = type
  if (type == 'full') anchor = undefined

  const newUrl = router.resolve({
    name: 'report',
    query: {
      address: target.address,
      type: target.coin,
      exampleId: target.exampleId,
      anchor,
    },
  }).href

  window.open(newUrl, '_blank')
}

export const openProfilePlan = ({ planTier, billingCycle, isTrialRequest, actionStatus } = {}) => {
  if (!planTier) return

  const newUrl = router.resolve({
    name: 'changePlan',
    query: {
      planTier,
      billingCycle,
      isTrialRequest,
      actionStatus
    },
  }).href

  window.location.href = newUrl
}
